<template>
  <div>
    <iframe src="privacy.html" style="width: 100%; height: 100vh;" frameBorder="0"></iframe>
  </div>
</template>
